import React from 'react';
export function Footer() {
  return <footer className="defer-paint w-full border-t border-line bg-ink py-10" data-id="element-71" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-5xl px-6 text-center" data-id="element-72" data-mp="3ggaqtvj9sd5g">
        <p className="font-display text-base font-bold uppercase tracking-[0.3em] text-ivory" data-id="element-73" data-mp="32nulup6t651w">
          Megapack <span className="text-gold" data-id="element-74" data-mp="36p6df098t0cq">Atletismo 360</span>
        </p>
        <div className="mx-auto mt-6 h-px w-16 bg-gold/50" aria-hidden="true" data-id="element-75" data-mp="36nd4tff2k623" />
        <p className="mt-6 font-sans text-xs leading-relaxed text-stone" data-id="element-76" data-mp="3ufjw405xtmun">
          © 2026 Megapack Atletismo 360 — Todos los derechos reservados.
        </p>
        <p className="mx-auto mt-2 max-w-xl font-sans text-[11px] leading-relaxed text-stone" data-id="element-77" data-mp="3levhb38pzigp">
          Material digital de entrenamiento para entrenadores de atletismo. Los
          resultados dependen de cómo se aplique el sistema en los
          entrenamientos reales.
        </p>
      </div>
    </footer>;
}